/*  store.js
    Offers a single source of truth for state management.
    by Guy E. White <guw968@g.harvard.edu>
*/

import Vue from 'vue'
import Vuex from 'vuex'
import * as app from '@/common/app.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        mytestsCount: 0,
        products: [],
    },
    mutations: {
        setMyTestsCount(state, payload) {
            state.mytestsCount = payload;
        },
        updateMyTestsCount(state, payload) {
            state.mytestsCount += payload;
        },
        updateProducts(state, payload) {
            state.products = payload;
        }
    },
    actions: {
    setProducts(context) {
        app.api.all('tests').then(response => {
            context.commit('updateProducts', response);
        });
    }
}
})
